import React, { useEffect } from "react";
import values from "../../../../../../../values";
import Context from "../../../../../../../context";

import { IItem } from "../../../../../../../types/common.interface";
import { useFormik } from "formik";
import {
  CustomView,
  CustomInput,
  ImageUploader,
  CustomButton2,
  CustomCheckBox,
  CustomTimePiker,
  CustomDropdownSearch,
} from "../../../../../../../components";

import * as Yup from "yup";
import { IUpdateStudent } from "../../../../../../../types/student.interface";
import validations from "../../../../../../../validations";

type Props = {
  onBack: (event: IUpdateStudent) => void;
  onSubmit: (event: IUpdateStudent) => void;
  defaultValues: IUpdateStudent;
};

const StudentInformation = (props: Props) => {
  const { isLoading, uploadImage, setShowModal, selectedUser } =
    React.useContext(Context.ServiceScreen);
  const selectedStudent = selectedUser?.student;
  const [selectedImage, setSelectedImage] = React.useState<any>();
  const [selectedGrade, setSelectedGrade] = React.useState<IItem | undefined>(
    props?.defaultValues?.grade
  );
  const [selectedField, setSelectedField] = React.useState<IItem | undefined>();
  const [selectedGender, setSelectedGender] = React.useState<IItem | undefined>(
    props?.defaultValues?.gender
  );
  const [selectedBirthDate, setSelectedBirthDate] = React.useState<
    string | undefined
  >(props?.defaultValues?.birthDate);
  const [disability, setDisability] = React.useState<boolean>(
    props?.defaultValues?.disability ? props?.defaultValues?.disability : false
  );
  const [dropDownErrors, setDropDownErrors] = React.useState<any>({
    field: "",
    gender: "",
    grade: "",
    birthDate: "",
  });

  async function onUploadImage(imageFile: File) {
    const imagePromise = await uploadImage!(imageFile);

    if (imagePromise?.CODE === 2042) setSelectedImage(imagePromise?.result);
  }

  // ?? ===========================================================================================================
  // ??                                           Use Formik Function
  // ?? -----------------------------------------------------------------------------------------------------------
  // console.log(props?.defaultValues);
  useEffect(() => {
    setSelectedGender(
      values.dropdownItems.GENDER.find(
        (item: IItem) => item.value === props?.defaultValues?.gender
      )
    );
    setSelectedGrade(
      values.dropdownItems.GRADE.find(
        (item: IItem) => item.value === props?.defaultValues?.grade
      )
    );
    setSelectedImage({ link: props?.defaultValues?.avatar });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUser]);

  const formik = useFormik<IUpdateStudent>({
    enableReinitialize: true,
    initialValues: {
      ...props?.defaultValues,
    },
    validationSchema: Yup.object({
      lastName: validations.yupValidations.lastName,
      firstName: validations.yupValidations.firstName,
      nationalCode: validations.yupValidations.nationalCode,
    }),
    onSubmit: (values: IUpdateStudent, { setSubmitting }) => {
      const formValues: IUpdateStudent = {
        ...values,
        grade: selectedGrade,
        field: selectedField,
        gender: selectedGender,
        avatar: selectedImage?.link,
        birthDate: selectedBirthDate,
        disability,
      };
      if (
        selectedGrade &&
        (Number(selectedGrade._id as string) <= 9 || selectedField) &&
        selectedGender &&
        selectedBirthDate
      ) {
        Promise.resolve(props.onSubmit(formValues)).catch((e) =>
          setSubmitting(false)
        );
      }
    },
  });

  const submitHandler = () => {
    let dropDownErrorsList = {
      field: "",
      gender: "",
      grade: "",
      birthDate: "",
    };
    if (!selectedGender) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        gender: "انتخاب جنسیت اجباری است",
      };
    }
    if (!selectedGrade) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        grade: "انتخاب پایه تحصیلی اجباری است",
      };
    }
    if (!selectedField) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        field: "انتخاب شرکت اجباری است",
      };
    }

    if (!selectedBirthDate) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        birthDate: "انتخاب تاریخ تولد اجباری است",
      };
    }

    setDropDownErrors(dropDownErrorsList);

    formik.submitForm();
  };

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <form onSubmit={submitHandler}>
      <CustomView.Container className="create-form-content">
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum">
            <CustomInput
              name="firstName"
              id="firstName"
              label="نام"
              value={formik.values.firstName}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.firstName && formik.touched.firstName}
              errorText={formik.errors.firstName}
            />
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum">
            <CustomInput
              name="lastName"
              id="lastName"
              label="نام خانوادگی"
              value={formik.values.lastName}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.lastName && formik.touched.lastName}
              errorText={formik.errors.lastName}
            />
          </CustomView.Column>
        </CustomView.Row>
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">جنسیت</label>
            <CustomDropdownSearch
              items={values.dropdownItems.GENDER}
              itemName="name"
              placeHolder="جنسیت"
              defaultItem={selectedGender}
              onSelectItem={(event: any) => {
                setSelectedGender(event);
                setDropDownErrors({ ...dropDownErrors, gender: "" });
              }}
            />
            <div className="error">
              {dropDownErrors.gender !== "" && dropDownErrors.gender}
            </div>
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">مقطع تحصیلی</label>
            <CustomDropdownSearch
              items={values.dropdownItems.GRADE}
              itemName="name"
              placeHolder="مقطع تحصیلی"
              defaultItem={selectedGrade}
              onSelectItem={(event: any) => {
                setSelectedField(undefined);
                setSelectedGrade(event);
                setDropDownErrors({ ...dropDownErrors, grade: "" });
              }}
            />
            <div className="error">
              {dropDownErrors.grade !== "" && dropDownErrors.grade}
            </div>
          </CustomView.Column>
        </CustomView.Row>
        {selectedGrade !== undefined &&
          (selectedGrade?._id === "10" ||
            selectedGrade?._id === "11" ||
            selectedGrade?._id === "12") && (
            <CustomView.Row className="form-row">
              <CustomView.Column medium={6} className="form-colum">
                {" "}
              </CustomView.Column>
              <CustomView.Column medium={6} className="form-colum dropdown">
                <label className="form-label">رشته‌ی تحصیلی</label>
                <CustomDropdownSearch
                  items={values.dropdownItems?.FIELD}
                  itemName="name"
                  placeHolder="رشته‌ی تحصیلی"
                  defaultItem={
                    selectedField
                      ? selectedField
                      : values.dropdownItems?.FIELD?.find(
                          (item) => item._id === selectedStudent?.field
                        )
                  }
                  onSelectItem={(event: any) => {
                    setSelectedField(event);
                    setDropDownErrors({ ...dropDownErrors, field: "" });
                  }}
                />
                <div className="error">
                  {dropDownErrors?.field !== "" && dropDownErrors.field}
                </div>
              </CustomView.Column>
            </CustomView.Row>
          )}
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum">
            <CustomInput
              name="state"
              id="state"
              label="منطقه"
              value={formik.values.state}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.state && formik.touched.state}
              errorText={formik.errors.state}
            />
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">تاریخ تولد</label>
            <CustomTimePiker
              defaultValue={
                selectedBirthDate ? selectedBirthDate : selectedUser?.expire
              }
              onChange={(event: string) => {
                setSelectedBirthDate(event);
                setDropDownErrors({ ...dropDownErrors, birthDate: "" });
              }}
            />
            <div className="error">
              {dropDownErrors.birthDate !== "" && dropDownErrors.birthDate}
            </div>
          </CustomView.Column>
        </CustomView.Row>
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum">
            <CustomInput
              name="sanadCode"
              id="sanadCode"
              label="کد سناد"
              value={formik.values.sanadCode}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.sanadCode && formik.touched.sanadCode}
              errorText={formik.errors.sanadCode}
            />
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum">
            <CustomInput
              name="nationalCode"
              id="nationalCode"
              label="کد ملی"
              value={formik.values.nationalCode}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.nationalCode && formik.touched.nationalCode}
              errorText={formik.errors.nationalCode}
              maxLength={10}
            />
          </CustomView.Column>
        </CustomView.Row>
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="">
            <CustomCheckBox
              isChecked={disability ? disability : selectedStudent?.disability}
              onChecked={() => setDisability(!disability)}
              label="دارای ناتوانی"
            />
          </CustomView.Column>
          <CustomView.Column medium={6} className="">
            <ImageUploader
              defaultImage={selectedImage}
              setImage={setSelectedImage}
              uploadImage={(event: any) => onUploadImage(event)}
            />
          </CustomView.Column>
        </CustomView.Row>

        <CustomView.Row className="form-row">
          <CustomView.Column
            large={3}
            medium={4}
            small={6}
            className="form-colum"
          >
            <CustomButton2
              isLoading={isLoading}
              onClick={() => setShowModal!("NONE")}
              title="لغو"
              type="danger"
            />
          </CustomView.Column>
          <CustomView.Column
            large={3}
            medium={4}
            small={6}
            className="form-colum"
          >
            <CustomButton2
              isLoading={isLoading}
              onClick={submitHandler}
              title="بعدی"
            />
          </CustomView.Column>
        </CustomView.Row>
      </CustomView.Container>
    </form>
  );
};

export default StudentInformation;
